import { Link } from "react-router-dom";
import { BrandLogo } from "@/components/brand";

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-surface">
      {/* Left brand panel (desktop) */}
      <div className="relative hidden lg:flex flex-col justify-between bg-brand p-12 text-white overflow-hidden">
        <BrandLogo className="[&_span]:text-white [&_.text-brand-accent]:text-white/70" />
        <div className="relative z-10 max-w-md">
          <h2 className="font-heading text-3xl font-extrabold leading-tight">
            Lebih yakin memilih ide bisnis yang cocok dengan kondisi Anda.
          </h2>
          <p className="mt-4 text-white/70 leading-relaxed">
            Temukan, bandingkan, dan validasi peluang bisnis berdasarkan modal, kemampuan, waktu, dan kondisi Anda.
          </p>
          <ul className="mt-8 space-y-3 text-sm text-white/80">
            <li>• Rekomendasi personal sesuai situasi Anda</li>
            <li>• Validasi terstruktur sebelum modal keluar</li>
            <li>• Business winner + rencana eksekusi</li>
          </ul>
        </div>
        <div className="relative z-10 text-sm text-white/50">© {new Date().getFullYear()} IDEbisnis AI</div>
        <div className="pointer-events-none absolute -right-24 -bottom-24 h-80 w-80 rounded-full bg-white/5" />
        <div className="pointer-events-none absolute right-10 top-16 h-40 w-40 rounded-full bg-white/5" />
      </div>

      {/* Right form panel */}
      <div className="flex flex-col justify-center px-5 sm:px-10 py-10">
        <div className="mx-auto w-full max-w-md">
          <div className="lg:hidden mb-8">
            <BrandLogo />
          </div>
          <h1 className="font-heading text-2xl sm:text-3xl font-extrabold tracking-tight text-ink">{title}</h1>
          {subtitle && <p className="mt-2 text-ink-soft">{subtitle}</p>}
          <div className="mt-8">{children}</div>
          {footer && <div className="mt-6 text-center text-sm text-ink-soft">{footer}</div>}
          <div className="mt-8 text-center">
            <Link to="/" className="text-sm text-ink-muted hover:text-brand transition-colors">← Kembali ke beranda</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
